import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { LivedataProvider } from '../providers/livedata/livedata';
import { DetailsPage } from '../pages/details/details';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = HomePage;
  pages: Array<{ title: string, component: any }>;
  subpages: Array<{ title: string, component: any }>;
  data: any;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public dataProvider: LivedataProvider,
    public events: Events
  ) {
    this.initializeApp();
    this.pages = [
      { title: 'Home', component: HomePage }
    ];

    events.subscribe('data:synced', (result) => {
      this.data = result;
      let pages = [];
      for (let item of result.allData) {
        pages.push({
          "title": item.model,
          "component": DetailsPage
        });
      }
      this.subpages = pages;
    });
    this.getData();
  }

  getData() {
    this.dataProvider.getData().then((result: any) => {
      this.data = result;
      let pages = [];
      for (let item of result.allData) {
        pages.push({
          "title": item.model,
          "component": DetailsPage
        });
      }
      this.subpages = pages;
    });
  }
  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are availabel.
      // Here you can do any higher level native things you might need.
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#0a3579');
      this.splashScreen.hide();

      // setTimeout(function () {
      //   this.addToHome();
      // }, 5000);
    });
  }

  isInstalled() {
    // TODO: check if installed already and hide button
    return false;
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    // console.log(page);
    this.nav.setRoot(page.component, { pageData: this.data, model: page.title });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts